import { z } from "zod";
import { PastDaysNumberMessage, ReuseSchema } from "@/schemas/acquirebook";

// 物件概要書の検索絞り込みスキーマ
export const PropertySummarySearchSchema = z.object({
  keyword: z.string(), // キーワード
});

export type PropertySummarySearchForm = z.infer<
  typeof PropertySummarySearchSchema
>;

const FileSchema = z.instanceof(File, { message: "画像が設定されていません" });

// 物件概要書 編集 スキーマ
export const PropertySummaryEditSchema = z.object({
  // 基本情報
  buildingName: z.string(), // 建物名
  price: z.string().nullable(),

  lat: z.number().nullable(),
  lng: z.number().nullable(),

  // 所在地
  address: z.string().nullable().readonly(),
  chiban: z.string().nullable().readonly(),
  kaokuNumbersDisplay: z.string().nullable().readonly(),

  // 交通
  access: z.string().nullable(),

  // 土地
  landArea: z.string().nullable(),
  landCategory: z.string().nullable(),
  areaUsePurpose: z.string().nullable(),
  ordinance: z.string().nullable(),
  buildingCoverageRatio: z.string().nullable(),
  volumeRate: z.string().nullable(),

  // 建物
  buildingVariant: z.string().nullable(),
  buildingType: z.string().nullable(),
  area: z.string().nullable(),
  buildDate: z.date().nullable(),
  balconyArea: z.string().nullable(),
  buildingCount: z.string().nullable(),

  // 利回り
  yield: z.string().nullable(),

  // 備考
  remarks: z.string().nullable(),

  // 自由記述
  description: z.string().nullable(),

  mapPhotos: z.array(
    z.object({
      id: z.number().nullable(),
      display_order: z.number(),
      url: z.string().url(),
      file: FileSchema.nullable(),
    })
  ),

  sitePhoto_1: z.object({
    id: z.number().nullable(),
    file: FileSchema.nullable(),
    url: z.string().url().nullable(),
  }),

  sitePhoto_2: z.object({
    id: z.number().nullable(),
    file: FileSchema.nullable(),
    url: z.string().url().nullable(),
  }),
});

export type PropertySummaryEditForm = z.infer<typeof PropertySummaryEditSchema>;

// 物件概要書 新規追加

export const PropertySummaryNewSchema = z.object({
  pastDays: z.number({
    invalid_type_error: PastDaysNumberMessage,
    required_error: PastDaysNumberMessage,
  }),
  kaokuNumbersDisplay: z.array(z.string()),
  primaryKaokuNumber: z.string(),
  mapImage: FileSchema,
  requestClosureBook: z.boolean(),
  pictureCheckOptionsLand: ReuseSchema.nullable(),
  pictureCheckOptionsBuilding: ReuseSchema.nullable(),
  latitude: z.number(),
  longitude: z.number(),
});

export type PropertySummaryNewForm = z.infer<typeof PropertySummaryNewSchema>;
